<template>
    <div class="consultation-header">
        <div class="header-first">
            <div style="text-align:center;font-family: Microsoft YaHei;font-weight: bold;color: #272727;margin-top:15px;font-size:22px"><span>远程会诊</span></div>
        </div>
        <div class="header-second">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>产品简介</span></div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20px">远程会诊支持跨专科、跨机构、跨区域的多专家提供远程视音频实时高清会诊，提供会诊前、中、后不同环节的流程管理。会诊前下级医院提交会诊患者</div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">信息，包括病历信息及各检查和检验结果，经过质检后上级医院安排专家并确定会诊时间。会诊时，专家通过高清视频与患者及下级医院医生进行交流，</div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">并查看患者病历信息，会诊结束后给出相关诊断报告， 下级医院查看会诊报告并完成会诊。会诊过程可以选择进行直播，供其他医生进行观摩学习。</div>
            <div style="margin-top:25px">
                <img src="@/assets/image/yuanhuizhen.png" alt="">
                <div style="margin-top:15px">
                    <span style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;">远程会诊管理支持PC端和移动端，基层医院可以通过手机拍照上传患者信息。 平台支持Dicom3影像文件的页面浏览，让专家查看患者信息更方便。 </span>
                </div>
            </div>
            <div style="margin-top:25px">
                <img src="@/assets/image/yuanhuizhen1.png" alt="">
            </div>
        </div>
        <div class="header-firth">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>产品框架</span></div>
            <div>
                <img src="@/assets/image/yuanhuizhen2.png" alt="">
            </div>
        </div>
        <div class="header-forth">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px;margin-top:10px"><span>应用亮点</span></div>
            <div style="display:flex;justify-content:space-between;margin-top:20px;flex-wrap: wrap">
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;background: #FFFFFF;display: flex;align-items: center">
                    <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/tu.png" alt="">
                        </div>
                        <div style="padding-left:15px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>多终端支持</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px"><span>支持多种会诊室、医生办公室、个人笔记本、移动端等各种</span></div>
                            <div style="margin-top:5px;font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;">
                                <span>终端接入，让会诊随时随地可以接入</span>
                            </div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;display: flex;align-items: center">
                            <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/tu1.png" alt="">
                        </div>
                        <div style="padding-left:15px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>融合性</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px"><span>支持与医院的HIS、Pacs、互联网医院等系统对接，让整个</span></div>
                            <div style="margin-top:5px;font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;">
                                <span>会诊流程更简单</span>
                            </div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;background: #FFFFFF;margin-top:25px;display: flex;align-items: center">
                                    <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/tu2.png" alt="">
                        </div>
                        <div style="padding-left:15px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>专业化</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px"><span>支持专业Dicom3影像文件直接管理和显示，支持报告模板</span></div>
                            <div style="margin-top:5px;font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;">
                                <span>管理</span>
                            </div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;margin-top:25px;display: flex;align-items: center">
                        <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/tu3.png" alt="">
                        </div>
                        <div style="padding-left:15px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>易集成</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px"><span>提供第三方集成接口，方便与其他系统无缝集成</span></div>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .consultation-header{
        width: 100%;
        padding-left: 20px;
        .header-forth{
            margin-right:70px;
        }

    }
</style>